import { useMemo }  from "react";
import cx from "components/src/utils/cx";
import { normalizeSport } from "shared/src/utils/sportMap";

export const CompetitorWrapper = ({ variant, showComputedIcon, activeIcon, className, inline, sport: _sportRaw, compact, ariaLabel, tabbable, rest, children }) => {
    const sport = normalizeSport(_sportRaw);
    const competitorWrapperAttrs = useMemo(() => {
        const [isHorizontal, isVertical] = [variant === "horizontal", variant === "vertical"];
        const variantClasses = cx({
          "cui-inline-flex": isHorizontal,
          "cui-w-full": !inline && isHorizontal,
          "cui-w-auto": inline || isVertical,
          "cui-inline-grid cui-grid-cols-[auto,1fr,auto]":
            isVertical,
          "cui-gap-2xs": isVertical && showComputedIcon,
        });
        const {flipIcon, animation, competitionType, ..._rest} = rest; // prevent non-DOM props from being spread on the div element
        return {
          className:
            `cui__competitor_wrapper cui-relative ${variantClasses} ${className}`.trim(),
          "aria-label": ariaLabel,
          tabIndex: tabbable ? 0 : -1,
          role: "group",
          "data-haslogo": !!showComputedIcon || (sport === "football"),
          ..._rest,
        };
      }, [variant, ariaLabel, tabbable, rest, showComputedIcon]);
      
    return <div {...competitorWrapperAttrs}>
        {children}
    </div>
}